import { Student } from './student'
import { Clazz } from './clazz'

export enum StudentLeave {
  personal = '事假',
  sick = '病假',
  other = '其他',
}

export interface IExemptionForm {
  user_id: string
  type: string
  start_time: string
  end_time: string
  attachments?: (string | null)[]
}

export interface IExemption {
  id: string
  student: Student
  clazz: Clazz
  teacher_user_id: string
  start_time: string
  end_time: string
  type: string
  attachments?: (string | null)[]
}

export interface IStudentLeaveForm {
  type: string
  start_time: string
  end_time: string
  attachments?: (string | null)[]
}
